var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7514 5.00446C12.0359 4.99446 12.3249 5.00146 12.6169 5.02646C16.0604 5.32146 18.8194 8.19096 18.9909 11.643C19.1914 15.671 15.9844 19 11.9999 19C8.43886 19 5.49836 16.3405 5.05736 12.8995C4.99186 12.3905 4.57686 12 4.06386 12H3.05636C2.46986 12 1.99536 12.504 2.05836 13.087C2.61886 18.272 7.14286 22.269 12.5384 21.986C17.5859 21.7215 21.7209 17.5865 21.9859 12.5385C22.2879 6.77096 17.7014 1.99996 11.9999 1.99996C10.4614 1.99996 9.00386 2.34746 7.70136 2.96846L6.12536 1.02246L5.06886 6.39296C5.01586 6.66196 5.21936 6.91296 5.49336 6.91746L10.9664 7.00096L9.07136 4.66046",
    stroke: "#3545DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReselect);
export default __webpack_public_path__ + "static/media/reselect.84ead33d21c1f45845b3ee66a1ada2ac.svg";
export { ForwardRef as ReactComponent };